module.exports = __webpack_public_path__ + "static/media/4.1fdc0062.jpg";